import { Component, Input, inject } from '@angular/core';

import { MenuContentItem, MenuDisplayMode, MenuSection, trackByProp } from '@frontend/vanilla/core';
import { MenuItemComponent } from '@frontend/vanilla/features/menus';
import { ProductMenuConfig, ProductMenuService } from '@frontend/vanilla/shared/product-menu';

@Component({
    imports: [MenuItemComponent],
    selector: 'vn-product-menu-apps',
    templateUrl: 'product-menu-apps.html',
})
export class ProductMenuAppsComponent {
    @Input() useFastIconType: boolean;

    readonly config = inject(ProductMenuConfig);
    readonly productMenuService = inject(ProductMenuService);

    readonly MenuDisplayMode = MenuDisplayMode;
    readonly MenuSection = MenuSection;
    readonly trackByProp = trackByProp<MenuContentItem>('id');
}
